/** Marketing stewards — Projects + Budget portfolio. */
export const MARKETING_PORTFOLIO_ROLES = [
  "marketing_manager",
  "brand_manager",
  "pr_manager",
];

/** Marketing IC — sprint/tasks only (developer-style). */
export const MARKETING_EXECUTION_ROLES = [
  "marketing_designer",
  "content_marketer",
  "trainee",
  "sales_marketing",
];

export function isMarketingPortfolioRole(role) {
  return MARKETING_PORTFOLIO_ROLES.includes(String(role || "").toLowerCase());
}

export function isMarketingExecutionRole(role) {
  return MARKETING_EXECUTION_ROLES.includes(String(role || "").toLowerCase());
}
